'use client';
import type { ReactElement } from 'react';
import { BAR_RADIUS } from './gantt-constants';
import type { GanttBarTrackModel } from './gantt-bar-selectors';
export interface GanttBarTrackProps {
    track: GanttBarTrackModel;
}
export function GanttBarTrack({ track }: GanttBarTrackProps): ReactElement {
    return (
      <rect x={track.x} y={track.y} width={track.width} height={track.height} rx={BAR_RADIUS} fill={track.fill} stroke={track.stroke} strokeWidth={track.strokeWidth}/>
    );
}
